<div class="section-container">
    <div class="section-title">
        <mat-icon>{{ icone }}</mat-icon>
        <span>{{ titulo }}</span>
    </div>

    <div class="row g-2">
        <div class="col-12">
            <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                <mat-label>{{ titulo }}</mat-label>
                <app-observacao-editor #obsEditor [formControl]="control" [placeholder]="placeholder" [variaveis]="variaveis" [rows]="4"></app-observacao-editor>
            </mat-form-field>
        </div>

        <div class="col-12 variaveis-trigger-row">
            <span class="variaveis-link-inline" role="button" (mousedown)="obsEditor.saveSelection(); $event.preventDefault()" (click)="onClicarVariaveis()">
                <mat-icon>data_object</mat-icon>
                @if (variaveisInline && variavelAberto) {
                    Ocultar variáveis disponíveis
                } @else {
                    Exibir variáveis disponíveis
                }
            </span>
        </div>

        @if (variaveisInline && variavelAberto) {
        <div class="col-12">
            <app-variaveis-disponiveis-section [variaveis]="variaveis" (variavelSelecionada)="obsEditor.inserirVariavel($event)"></app-variaveis-disponiveis-section>
        </div>
        }
    </div>
</div>
